import React, { useEffect, useState } from 'react';
import { Col, Row } from 'antd';
import Loading from '../../Loading';
import TitleContent from '../../TinyComponents/TitleContent';
import Container from '../../Home/Container';
import { LocalizationContext } from '../../../hoc/Localization';
import { SettingsContext } from '../../../hoc/Settings';
import Link from '../../Link';
import { getPaths } from '../../../utils/api';
import CardItem from '../components/cart-item/card-item';
import translitString from '../../TranslitString';

import styles from './paths-list.less';

const PathsList = () => {
  const { t, locale } = React.useContext(LocalizationContext);
  const {
    domainSettings: { domain },
  } = React.useContext(SettingsContext);

  const [paths, setPaths] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      setPaths((await getPaths(domain)).data);
      setLoading(false);
    })();
  }, []);

  return (
    <>
      {loading ? (
        <Loading full />
      ) : (
        <Container>
          <TitleContent
            title={
              <>
                <h2>{t('paths.list.title')}</h2>
                <p className={styles.subTitle}>{t('paths.list.description')}</p>
              </>
            }
            content={
              <div className={styles.container}>
                <Row className={styles.row} type="flex" gutter={20}>
                  {paths.length ? (
                    <>
                      {paths.map(item => (
                        <Col lg={8} md={12} sm={24} xs={24} key={item.id}>
                          <Link
                            route="paths"
                            locale={locale}
                            profession={
                              item.profession
                                ? translitString(item.profession.title, true)
                                : 'profession'
                            }
                            name={translitString(item.title, true)}
                            id={item.id}
                          >
                            <CardItem
                              alt={item.title}
                              imageUrl={item.image}
                              description={item.description}
                              title={item.title}
                            />
                          </Link>
                        </Col>
                      ))}
                    </>
                  ) : (
                    <div className={styles.resultNotification}>
                      <h3>{t('noresults.header')}</h3>
                    </div>
                  )}
                </Row>
              </div>
            }
          />
        </Container>
      )}
    </>
  );
};

export default PathsList;
